export const KEY_AUTH_TOKEN = '_key_auth_token';

export const CURRENT_USER = '_current_user_info';

export const IS_REMEMBERED = '_isRemembered';

export const ANOTHER_DEVICE = '_anotherDevice';

export const GOOGLE_MAP_API_KEY = 'AIzaSyDUPRPsf_iwV3lStr4yCZxos3epeXf-S0M';